import { render, staticRenderFns } from "./BasePassword.vue?vue&type=template&id=dbf97a04&"
import script from "./BasePassword.vue?vue&type=script&lang=js&"
export * from "./BasePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports